import parse from 'date-fns/parse';
import format from 'date-fns/format';
import add from 'date-fns/add';

const MILESTONES = [30, 60, 90, 120, 150, 180, 210];

let dates = [];

const controller = document.querySelector(
	'[data-controller="vaccination-calculator"]'
);

const targets = Array.from(
	controller?.querySelectorAll('[data-target]') ?? []
).reduce(
	(targets, target) => ({
		...targets,
		[target.dataset.target]: target,
	}),
	{}
);

targets.form.addEventListener('submit', async (event) => {
	event.preventDefault();
	const formData = new FormData(event.target);
	const birthDate = parse(
		formData.get('birth_date'),
		'yyyy-MM-dd',
		new Date()
	);
	formData.set('birth_date', format(birthDate, 'MM/dd/yyyy'));
	formData.append('action', 'handle_vaccination_calculator_submission');

	document.querySelector('#vaccination-calculator-error')?.remove();
	targets.sendEmail.disabled = true;

	try {
		const response = await fetch('/wordpress/wp-admin/admin-ajax.php', {
			method: 'POST',
			body: formData,
		});

		if (response.ok) {
			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.style.display = 'none';
			a.href = url;
			a.download = 'vaccination_calculator_data.xlsx';
			document.body.appendChild(a);
			a.click();
			window.URL.revokeObjectURL(url);
			targets.sendEmail.disabled = false;
			targets.emailField.outerHTML = `
			<div class="alert alert-success not-prose" role="alert" style="max-width: 768px;">
			  <p>Thank you for using our vaccination calculator! Your form should have downloaded.</p>
			</div>
			      `;
		} else {
			event.target.querySelector('button[type="submit"]').disabled =
				false;
			const message = await response.json();
			targets.emailField.insertAdjacentHTML(
				'beforeend',
				`
<div class="alert alert-error col-span-full not-prose" id="vaccination-calculator-error" role="alert">
  <p>${message.data}</p>
</div>
        `
			);
		}
	} catch (error) {
		console.error('Error:', error);
	}
});

requiredFields().forEach((input) => {
	input.addEventListener('change', () => {
		targets.submit.disabled = !formIsValid();
	});
});

// Add email validation function
function isValidEmail(email) {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(email);
}

targets.emailField
	.querySelector('input')
	.addEventListener('change', (event) => {
		targets.sendEmail.disabled = !isValidEmail(event.target.value);
	});

targets.submit.addEventListener('click', () => {
	toggleResults(false);
	applyDates();
});

function formIsValid() {
	return Array.from(requiredFields()).reduce((isValid, field) => {
		if (!isValid) return isValid;
		return field.value !== '';
	}, true);
}

function requiredFields() {
	return targets.form.querySelectorAll('[required]');
}

function applyDates() {
	const birthDate = parse(targets.birthDate.value, 'yyyy-MM-dd', new Date());

	dates = calculateVaccinationDatesFrom(birthDate);

	targets.resultsWrapper
		.querySelectorAll('[data-result-field]')
		.forEach((el, index) => {
			el.value = format(dates[index], 'MM/dd/yyyy');
		});

	toggleResults(true);
	scrollToResults();
}

function toggleResults(isVisible) {
	targets.resultsWrapper.classList.toggle('hidden', !isVisible);
}

function scrollToResults() {
	const rect = targets.resultsWrapper.getBoundingClientRect();
	const scrollTop = document.documentElement.scrollTop;
	const distanceToTop = rect.top + scrollTop;
	window.scrollTo({
		top: distanceToTop - _getTopMargin(),
		behavior: 'smooth',
	});
}

function calculateVaccinationDatesFrom(date) {
	return MILESTONES.map((days) => add(date, { days }));
}

function _getTopMargin() {
	const adminBar = document.getElementById('wpadminbar');
	const header = document.querySelector('header.site-header');
	return (adminBar?.clientHeight ?? 0) + header.clientHeight + 16;
}
